export default __webpack_public_path__ + "static/media/umi.53996640.svg";